import { preloadImages, sleep } from './lib/utils.js';

//Detect if touching
window.addEventListener(
	'touchstart',
	function onFirstTouch() {
		window.USER_TOUCH = true;
		window.removeEventListener('touchstart', onFirstTouch, false);
	},
	false
);

// Matches $m3-viewport. Below this, .siteNav is position: fixed.
const tier1RevealQuery = window.matchMedia('(min-width: 940px)');
const TIER1_REVEAL_INTENT = 8;

const ff_nav: LegacyModule = {
	hasTier3Nav: false,
	openMenu: null,
	docked: false,
	revealed: false,
	lastScrollY: 0,
	scrollTravel: 0,
	tier0Height: 0,
	tier1Height: 0,

	init: function () {
		this.cache();
		this.events();
		this.initTabs();
		this.preloadImages();
		if (this.hasTier3Nav) {
			this.lastScrollY = window.scrollY || 0;
			this.updateTier1Reveal();
		}
	},

	cache: function () {
		this.$nav = document.querySelector('.siteNav');
		this.$tier0 = document.querySelector('.tier0Menu');
		this.$tier1 = document.querySelector('.tier1Menu');
		this.$tier2Triggers = document.querySelectorAll('.siteNav .js-tier2Trigger');
		this.tier2Menus = this.getTier2Menus();
		if (document.body.classList.contains('hasTier3Nav')) this.hasTier3Nav = true;
	},

	getTier2Menus: function () {
		var menus = {};
		var $menus = document.querySelectorAll('.siteNav .js-tier2Menu');
		for (var i = $menus.length - 1; i >= 0; i--) {
			var slug = $menus[i].getAttribute('data-menu');
			menus[slug] = $menus[i];
		}
		return menus;
	},

	events: function () {
		document.addEventListener('optimizedScroll', this.navScroll.bind(this));
		window.addEventListener('optimizedResize', this.navResize.bind(this));
		for (var i = 0; i < this.$tier2Triggers.length; i++) {
			this.$tier2Triggers[i].addEventListener('click', this.tier2TriggerClick.bind(this));
		}
	},

	navScroll: function () {
		if (this.hasTier3Nav && this.openMenu) {
			this.deactivateTriggers();
			this.closeMenu(this.openMenu);
		}
		this.updateTier1Reveal();
	},

	navResize: function () {
		if (!this.hasTier3Nav) return;
		if (!tier1RevealQuery.matches) {
			this.undockTier1();
			return;
		}
		this.measureTier1();
		this.updateTier1Reveal();
	},

	measureTier1: function () {
		if (!this.$tier1) return;
		this.tier1Height = this.$tier1.offsetHeight;
		if (this.$tier0) {
			var pad = parseFloat(getComputedStyle(this.$tier0).paddingBottom) || 0;
			this.tier0Height = this.$tier0.offsetHeight - pad;
		} else {
			this.tier0Height = 0;
		}
		document.body.style.setProperty('--tier1-height', this.tier1Height + 'px');
	},

	updateTier1Reveal: function () {
		if (!this.hasTier3Nav || !tier1RevealQuery.matches || !this.$tier1) return;

		var y = Math.max(window.scrollY || 0, 0);
		var delta = y - this.lastScrollY;
		this.lastScrollY = y;

		if (!this.docked) {
			if (this.$tier1.getBoundingClientRect().bottom > 0) return;
			this.dockTier1();
			if (this.docked && delta < -TIER1_REVEAL_INTENT) this.setTier1Revealed(true);
			return;
		}

		if (this.releaseTier1IfHome(y, delta)) return;
		if (!delta) return;

		if ((delta > 0 && this.scrollTravel < 0) || (delta < 0 && this.scrollTravel > 0)) {
			this.scrollTravel = 0;
		}
		this.scrollTravel += delta;
		if (this.scrollTravel > TIER1_REVEAL_INTENT) {
			this.scrollTravel = 0;
			this.setTier1Revealed(false);
		} else if (this.scrollTravel < -TIER1_REVEAL_INTENT) {
			this.scrollTravel = 0;
			this.setTier1Revealed(true);
		}
	},

	releaseTier1IfHome: function (y, delta) {
		var limit = this.revealed ? this.tier0Height : this.tier0Height + this.tier1Height;
		if (y <= limit && delta <= 0) {
			this.undockTier1();
			return true;
		}
		return false;
	},

	dockTier1: function () {
		this.measureTier1();
		if (!this.tier1Height) return;
		this.$tier1.style.transition = 'none';
		document.body.classList.add('nav-docked');
		this.docked = true;
		this.revealed = false;
		this.scrollTravel = 0;
		void this.$tier1.offsetHeight;
		this.$tier1.style.transition = '';
	},

	undockTier1: function () {
		if (!this.docked) return;
		document.body.classList.remove('nav-docked', 'nav-revealed');
		this.docked = false;
		this.revealed = false;
		this.scrollTravel = 0;
		if (this.$tier1) this.$tier1.style.transition = '';
	},

	setTier1Revealed: function (show) {
		if (this.revealed === show) return;
		this.revealed = show;
		this.scrollTravel = 0;
		document.body.classList.toggle('nav-revealed', show);
	},

	tier2TriggerClick: async function (e) {
		e.preventDefault();
		var $target = e.currentTarget;
		var menu = $target.getAttribute('data-menu');
		if (this.openMenu === menu) {
			this.deactivateTriggers();
			await this.closeMenu(menu);
		} else if (this.tier2Menus.hasOwnProperty(menu)) {
			if (this.openMenu) {
				this.deactivateTriggers();
				await this.closeMenu(this.openMenu);
			}
			$target.classList.add('active');
			$target.setAttribute('aria-expanded', 'true');
			this.showMenu(menu);
		}
	},

	showMenu: async function (menu) {
		this.tier2Menus[menu].style.display = 'block';
		await sleep(10);
		this.tier2Menus[menu].style.transform = 'none';
		this.openMenu = menu;
	},

	deactivateTriggers: function () {
		for (var i = 0; i < this.$tier2Triggers.length; i++) {
			this.$tier2Triggers[i].classList.remove('active');
			this.$tier2Triggers[i].setAttribute('aria-expanded', 'false');
		}
	},

	closeMenu: async function (key) {
		this.tier2Menus[key].style.transform = 'translateY(-100%)';
		await sleep(300);
		this.tier2Menus[key].style.display = 'none';
		this.openMenu = null;
	},

	initTabs: function () {
		this.$tabs = document.querySelectorAll('.js-menuTabs');
		for (var i = this.$tabs.length - 1; i >= 0; i--) {
			var tabs = new window.ff_navTab(this.$tabs[i]);
			tabs.init();
		}
	},

	preloadImages: function () {
		if (document.body.classList.contains('home')) return;

		var images = [];
		for (var slug in navTabs) {
			images.push(templateDirectoryUri + '/dist/images/nav/' + navTabs[slug].image);
		}
		preloadImages(images);
	},
};

const ff_mobileNav: LegacyModule = {
	open: false,

	init: function () {
		this.cache();
		this.events();
	},

	cache: function () {
		this.$mobileTrigger = document.querySelector('.js-mobileNavToggle');
		this.$mobileNav = document.querySelector('.js-mobileNav');
		this.$underlay = document.querySelector('.js-navUnderlay');
		this.$triggers = document.querySelectorAll('.js-mobileMenus .js-mobileNavTrigger');
		this.$closeTriggers = document.querySelectorAll('.js-mobileMenus .js-close');
		this.$menus = document.querySelectorAll('.js-mobileMenus .js-mobileMenu');
	},

	events: function () {
		this.$mobileTrigger.addEventListener('click', this.mobileTriggerClick.bind(this));
		for (var i = this.$triggers.length - 1; i >= 0; i--) {
			this.$triggers[i].addEventListener('click', this.triggerClick.bind(this));
		}
		for (var i = this.$closeTriggers.length - 1; i >= 0; i--) {
			this.$closeTriggers[i].addEventListener('click', this.closeClick.bind(this));
		}
		this.$underlay.addEventListener('click', this.closeNav.bind(this));
	},

	mobileTriggerClick: function (e) {
		e.preventDefault();
		if (this.open) {
			this.closeNav();
		} else {
			this.openNav();
		}
	},

	openNav: async function () {
		this.$mobileNav.style.display = 'flex';
		await sleep(10);
		this.$underlay.classList.add('active');
		this.$mobileTrigger.classList.add('active');
		this.$mobileNav.classList.add('active');
		this.open = true;
	},

	closeNav: async function () {
		this.$underlay.classList.remove('active');
		this.$mobileTrigger.classList.remove('active');
		this.$mobileNav.classList.remove('active');
		this.open = false;
		await sleep(300);
		this.closeAllMenus();
		this.$mobileNav.style.removeProperty('display');
	},

	triggerClick: function (e) {
		e.preventDefault();
		var $target = e.currentTarget;
		var slug = $target.getAttribute('data-menu');
		this.openMenu(slug);
	},

	openMenu: function (slug) {
		document.querySelector('.mobileMenu[data-menu="' + slug + '"]').classList.add('active');
	},

	closeAllMenus: function () {
		for (var i = this.$menus.length - 1; i >= 0; i--) {
			this.$menus[i].classList.remove('active');
		}
	},

	closeClick: function (e) {
		e.preventDefault();
		this.closeTopMenu();
	},

	closeTopMenu: function () {
		var $openMenus = document.querySelectorAll('.mobileMenu.active');
		if (!$openMenus.length) return;
		$openMenus[$openMenus.length - 1].classList.remove('active');
	},
};
ff_mobileNav.init();

class NavTabPanel {
	$el: Element;
	$tabs!: NodeListOf<Element>;
	$textWrapper!: Element | null;
	$imageWrapper!: Element | null;
	currentSlug?: string;

	constructor($el: Element) {
		this.$el = $el;
	}

	init() {
		this.cache();
		this.events();
		this.loadFirstTab();
	}

	loadFirstTab() {
		const slug = this.$tabs[0].getAttribute('data-slug');
		this.$tabs[0].classList.add('active');
		this.transitionTab(slug);
	}

	cache() {
		this.$tabs = this.$el.querySelectorAll('.js-tab');
		this.$textWrapper = this.$el.querySelector('.texts');
		this.$imageWrapper = this.$el.querySelector('.images');
	}

	events() {
		for (let i = this.$tabs.length - 1; i >= 0; i--) {
			this.$tabs[i].addEventListener('mousemove', this.tabClick.bind(this));
			this.$tabs[i].addEventListener('click', this.tabClick.bind(this));
		}
	}

	tabClick(e: Event) {
		if (window.USER_TOUCH) {
			e.preventDefault();
		}
		const $target = e.currentTarget as Element;
		const slug = $target.getAttribute('data-slug');
		if (!slug || slug === this.currentSlug) return;
		this.currentSlug = slug;
		this.removeTabActiveStates();
		$target.classList.add('active');
		this.transitionTab(slug);
	}

	removeTabActiveStates() {
		for (let i = this.$tabs.length - 1; i >= 0; i--) {
			this.$tabs[i].classList.remove('active');
		}
	}

	transitionTab(slug: string | null) {
		if (!slug || !navTabs.hasOwnProperty(slug)) return;
		const data = navTabs[slug];

		const $newImage = document.createElement('div');
		$newImage.classList.add('image');
		$newImage.style.backgroundImage =
			'url(' + templateDirectoryUri + '/dist/images/nav/' + data.image + ')';

		const $newText = document.createElement('div');
		$newText.classList.add('text');
		$newText.innerHTML =
			'<p class="tabPanelHl">' +
			data.title +
			'</p>\
		<p class="tabPanelDescription">' +
			data.description +
			' <a class="explore no-wrap" href="' +
			data.link +
			'" aria-label="' +
			data.ada_label +
			'">Explore &raquo;</a></p>';

		this.$textWrapper!.innerHTML = '';
		this.$imageWrapper!.appendChild($newImage);
		this.$textWrapper!.innerHTML = '';
		this.$textWrapper!.appendChild($newText);

		setTimeout(function () {
			$newImage.classList.add('active');
			$newText.classList.add('active');
		}, 10);
	}
}

window.ff_navTab = NavTabPanel;

ff_nav.init();
